export const css = {
    root: 'NbCbU1t9',
    header: 'y2OQmYIk',
    headerSmall: 'J4zSJgKv',
    title: 'BCl7nqJX',
    legend: 'EbmJN4BN',
    note: 'OnS6E1o7',
    wrapper: 'Dqm4MrE7',
    nav: '_3OROy0LF',
    disabled: '_7b2r0fZt',
    navLeft: '_1uvnDTKG',
    left: 'MMikp-TI',
    right: 'kLKd2Q65',
    content: 'zLm2dT84',
    seats: 's03oCkGw',
    seat: 'pJI8WKa2',
    hidden: 'jAd2cKTH',
    gridWrapper: 'e8BJ6dX5',
    grid: 'MSdAKlXe',
    gridseat: 'F6fHLKJH',
    ' _key': 'carousel/carousel'
};
export default css;
